import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { IServiceQueueInput } from "@/interfaces/service-queue.interface";
import serviceQueueService from "@/services/service-queue.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateServiceQueueProps = UpdateByIdProps<IServiceQueueInput>;

export type UseUpdateServiceQueueReturn = {
  update: (props: UpdateServiceQueueProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateServiceQueue = (): UseUpdateServiceQueueReturn => {
  const response = useUpdate<IServiceQueueInput>({
    operation: (formData, serviceQueueId) => serviceQueueService.update(formData, serviceQueueId),
  });

  const { isLoading, startLoading, endLoading, loadingIcon, update } = response;

  return { isLoading, startLoading, endLoading, loadingIcon, update };
};

export default useUpdateServiceQueue;
